import React, { Component } from 'react'
import FixedView from '../../components/FixedView'
import FormViewer from '../../components/FormViewer'
import SidebarView from '../../components/SidebarView'
import StagesManager from '../../components/StagesManager'
import { checkTranslation, translate } from '../../utils/useful'
import NewOtherAccount from './NewOtherAccount'
import StepTwo from './StepTwo'
import HttpServices from '../../utils/Http.services'



export default class EmailNewAccount extends Component {
    state = {
        Accounts: [
            { key: 'outlook', title: "Outlook", icon: "/assets/icons/email/outlook2.svg", func: 'openSidebar' },
            { key: 'microsoft', title: "Microsoft", icon: "/assets/icons/email/microsoft2.svg", func: 'openSidebar' },
            { key: 'google', title: "Google", icon: "/assets/icons/email/google2.svg", func: 'openSidebar' },
            { key: 'yahoo', title: "Yahoo", icon: "/assets/icons/email/yahoo2.svg", func: 'openSidebar' },
            { key: 'iCloud', title: "iCloud", icon: "/assets/icons/email/icloud2.svg", func: 'openSidebar' },
            { key: 'other', title: "{{lang}}mail.Other", func: 'openSidebar' },
        ],

        headers: [
            { key: 'name', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Name', placeholder: '{{lang}}John Applesed', required: true, }, showMain: false },
            { key: 'email', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Email', placeholder: '{{lang}}user@example.com', required: true, }, showMain: false },
            { key: 'password', type: 'PasswordInput', col: '12', information: { label: '{{lang}}mail.Password', placeholder: '{{lang}}*********', required: true, }, showMain: false },
            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}mail.Description', placeholder: '{{lang}}mail.My Email Account', required: true, }, showMain: false },

        ],
        data: {},
    }



    openSidebar = (key) => {
        this.setState({ currentTab: key }, () => {
            this.sidebarView.openSidebar()
        })
    }
    setData = (key, value, cb) => {

        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })

    }
    addAccounts = (cb) => {
        let body = this.state.data
        HttpServices.request('addAccount', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (fetchResult.info) {
                // let accounts = this.state.accounts
                // accounts.push(fetchResult.info)
                // this.setState({ accounts }, () => {
                    // this.AdminPerspective.forceUpdateHeader()
                    console.log('done')
                    this.sidebarView.close()
                    if (cb) {
                        cb()
                    }
                // })
            }
        })
    }
    render() {
        return (
            <div className='h-100 scroll-no-scrollbar w-100' style={{ backgroundColor: "#f6f6f6" }}>
                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>
                    <div className='h-100 scroll-no-scrollbar' style={{ backgroundColor: "#f6f6f6" }}>
                        <StagesManager height="100%" ref={el => this.stageManager = el} fast={true}>
                            <NewOtherAccount data={this.state.data} setData={this.setData} changeStage={this.changePage} width={this.props.width} stage={0} stageName={'first'} changePage={this.changePage} currentTab={this.state.currentTab} />
                            <StepTwo changeStage={this.changePage} addAccounts={this.addAccounts} data={this.state.data} setData={this.setData} width={this.props.width} stage={1} stageName={'second'} changePage={this.changePage} />
                        </StagesManager>
                    </div>
                </SidebarView>
                <div className=''>
                    {/* <div className='flexcb position-sticky top-0 blur-bg w-100 p-3' style={{ borderBottom: "1px solid #ddd" }}>
                        <button className='flexc' onClick={() => this.props.changeStage("first")}>
                            <img width={20} className='rtl-button' src='assets/icons/arrow-left-black.svg' />
                            <p className='font-size-15' style={{ color: "#222" }}>{translate('mail.New Account')}</p>
                        </button>
                        <button className='flexcc action-text' onClick={() => this.openSidebar()}>
                            <p className='font-size-15'>{translate('mail.Other')}</p>
                        </button>
                    </div> */}
                    <div className='m-3 br-15 shadow-2' style={{ backgroundColor: "#fff" }}>
                        {this.state.Accounts.map((prop, index) => {
                            return (
                                <div className='w-100 flexcc'>
                                    <button className='w-100 flexc account-mail px-3' onClick={() => { this[prop.func](prop.key) }}>
                                        <img width={26} className='mrd-5' src={prop.icon} />
                                        <p className='text-normal weight-600 w-100 py-4' style={{ borderBottom: '1px solid #eee', textAlign: 'start' }}>{checkTranslation(prop.title)}</p>
                                    </button>
                                </div>
                            )
                        })}

                    </div>
                </div>
            </div>
        )
    }
}
